import React from "react";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/select";
import { ClearButton } from "@/components/ui/ClearButton";
import { cn } from "@/utils";
import type { RowState, FieldSchema } from "@/components/advanceSearch/types";

interface Props {
  row: RowState;
  control: any;
  fieldSchema?: FieldSchema;
  onClear: (which: "value" | "value2") => void;
}

export const ConditionDropdownInput: React.FC<Props> = ({ row, control, fieldSchema, onClear }) => (
  <FormField
    control={control}
    name={`value_${row.id}` as const}
    rules={{ required: "This field is required." }}
    render={({ field }) => {
      const handleClear = () => {
        field.onChange("");
        onClear("value");
      };

      const hasValue = Boolean(field.value);
      const clearLabel = "Clear selected value";

      return (
        <FormItem className="relative">
          <Select value={field.value ?? ""} onValueChange={field.onChange}>
            <FormControl>
              <SelectTrigger
                className={cn(
                  "w-full justify-between rounded-md bg-white px-4 text-sm font-medium text-gray-700 shadow-none focus:ring-0",
                  hasValue ? "pr-8" : "pr-4"
                )}
              >
                <SelectValue placeholder="Select value" />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="w-full min-w-[unset]">
              {fieldSchema &&
                "options" in fieldSchema &&
                fieldSchema.options.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
          {hasValue && (
            <ClearButton
              onClick={handleClear}
              ariaLabel={clearLabel}
              title={clearLabel}
              className="absolute right-3 top-1/2 z-10 -translate-y-1/2"
            />
          )}
          <FormMessage className={"absolute left-0 top-full mt-1 text-xs text-red-600"} />
        </FormItem>
      );
    }}
  />
);
